const navikModule = require('./modules/navik')

module.exports = function installNavikStore (store) {
  store.registerModule('navik', navikModule({}), {
    preserveState: Boolean(store.state.navik) // false at init, true on client side - for SRR (https://vuex.vuejs.org/api/#registermodule)
  })
}
